import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { useTheme } from '@mui/material';

const Rating = ({ question }) => {
  const theme = useTheme();
  const color = theme.palette.primary.main;
  return (
    <>
      <Typography variant="subtitle1" fontWeight={500}>
        {question.question_label}
      </Typography>
      <Stack direction="row" spacing={2} justifyContent="center">
        <StarIcon sx={{ fontSize: 60, color }} />
        <StarIcon sx={{ fontSize: 60, color }} />
        <StarIcon sx={{ fontSize: 60, color }} />
        <StarOutlineIcon sx={{ fontSize: 60, color }} />
        <StarOutlineIcon sx={{ fontSize: 60, color }} />
      </Stack>
    </>
  );
};

export default Rating;
